<template>
  <v-text-field
    v-bind="defaultConfigs"
    @click:append-outer="search"
    @input="onInput"
    :value="value"
    v-on="$listeners"
  />
</template>
<script>
const defaultProp = {
  outlined: true,
  dense: true,
  "background-color": "white"
};
export default {
  model: {
    event: "update"
  },
  computed: {
    defaultConfigs() {
      return {
        ...this.$attrs,
        ...this.$props,
        placeholder: this.textPlaceholder,
        ...defaultProp
      };
    }
  },
  methods: {
    onInput(value) {
      this.$emit("update", value);
    },
    search() {
      this.$emit("search");
    }
  },
  props: {
    value: {
      type: String
    },
    textPlaceholder: {
      type: String
    }
  }
};
</script>
<style lang="sass">
.v-text-field--outlined fieldset
  border: 1px solid #D5D5E0
  border-radius: 2px !important
  border-top-right-radius: 0 !important
  border-bottom-right-radius: 0 !important
.filter__icon
  .theme--light.v-icon
    color: #059EE4
    font-size: 18px
.v-input__append-outer
  border: 1px solid #D5D5E0
  border-left: 0px !important
  border-radius: 2px
  box-sizing: border-box
  margin: 0 !important
  @media screen and (-webkit-min-device-pixel-ratio:0)
    top: 0.5px !important
    height: 39.5px !important
  top: 0px !important
  height: 40px !important
  position: relative !important
  background: #FFF
  min-width: 40px !important
  align-items: center
  border-top-left-radius: 0 !important
  border-bottom-left-radius: 0 !important
  padding: 0 !important
</style>
